import { render, staticRenderFns } from "./TvaLangSwitcher.vue?vue&type=template&id=a6c73324&scoped=true&"
import script from "./TvaLangSwitcher.vue?vue&type=script&lang=js&"
export * from "./TvaLangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TvaLangSwitcher.vue?vue&type=style&index=0&id=a6c73324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c73324",
  null
  
)

export default component.exports